module.exports = {
    START: 'START',
    END: 'END'
  };
  